module.exports = __webpack_public_path__ + "img/ensa_events.1f153bee.png";